module.exports = __webpack_public_path__ + "img/1554199940.e83db17f.jpg";